import React, { useState } from 'react';
import DefineBOSTab from '../components/bos/DefineBOSTab';
import CourseBOSAllocationTab from '../components/bos/CourseBOSAllocationTab';
import BOSMembersTab from '../components/bos/BOSMembersTab';
import { useAuth } from '../context/AuthContext';

const tabs = [
  { id: 'define', label: 'DEFINE BOS', icon: '🏛' },
  { id: 'allocation', label: 'COURSE BOS ALLOCATION', icon: '🔗' },
  { id: 'members', label: 'BOS MEMBERS', icon: '👤' },
];

function BOSManagement() {
  const [activeTab, setActiveTab] = useState('define');
  const { user } = useAuth();

  return (
    <div className="page-card">
      <div className="settings-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`settings-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className="settings-tab-icon">{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      <div className="settings-content">
        {activeTab === 'define' && <DefineBOSTab tenantId={user?.tenantId} />}
        {activeTab === 'allocation' && <CourseBOSAllocationTab tenantId={user?.tenantId} />}
        {activeTab === 'members' && <BOSMembersTab tenantId={user?.tenantId} />}
      </div>
    </div>
  );
}

export default BOSManagement;
